<ng-container *ngIf="installation">
  <div class="header">
    <mat-icon class="header__icon" (click)="closeOverlay()">close</mat-icon>
    <a
      data-at-installations-go-to-dashboard
      class="header__label"
      [routerLink]="['/installations', installation.id]"
      (click)="closeOverlay()"
    >
      {{ '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.NAVIGATION_LINK' | translate }}
      <mat-icon>arrow_right</mat-icon>
    </a>
  </div>
  <!-- Header  -->
  <app-kanban-quick-view-header
    [selectedDevice]="selectedDevice"
    [installation]="installation"
    [selectedDeviceIndex]="kanbanBoardStore.indexOfQuickViewSelectedDevice$ | async"
  ></app-kanban-quick-view-header>

  <!-- System status -->
  <mat-progress-spinner
    *ngIf="!(kanbanBoardStore.isSmartNotesFetched$ | async); else smartNotesData"
    mode="indeterminate"
  ></mat-progress-spinner>
  <ng-template #smartNotesData>
    <div class="status" *ngIf="kanbanBoardStore.isAnySystemStatusData$ | async">
      <div class="status__label">
        {{ '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.SYSTEM_STATUS' | translate }}
      </div>

      <div class="status__tiles">
        <!-- System locked -->
        <div
          class="status__tiles__entry system-locked"
          *ngIf="kanbanBoardStore.isSelectedDeviceWithSystemLocked$ | async"
        >
          <div class="status__tiles__entry__header">
            <h4>
              {{ '+INSTALLATIONS.INSTALLATION.ERROR_LIST.LOCKED_SYSTEM_ERROR.TITLE' | translate }}
            </h4>
          </div>
          <div class="status__tiles__entry__description">
            <span>
              {{
                '+INSTALLATIONS.INSTALLATION.ERROR_LIST.LOCKED_SYSTEM_ERROR.DESCRIPTION' | translate
              }}
            </span>
          </div>
        </div>

        <!-- Floor heating over heating -->
        <div
          class="status__tiles__entry floor-heating-over-heating"
          *ngIf="kanbanBoardStore.isSelectedDeviceWithFLoorHeatingOverHeating$ | async"
        >
          <div class="status__tiles__entry__header">
            <h4>
              {{
                '+INSTALLATIONS.INSTALLATION.ERROR_LIST.FLOOR_HEATING_OVER_HEATING_ERROR.TITLE'
                  | translate
              }}
            </h4>
          </div>
          <div class="status__tiles__entry__description">
            <span>
              {{
                '+INSTALLATIONS.INSTALLATION.ERROR_LIST.FLOOR_HEATING_OVER_HEATING_ERROR.DESCRIPTION'
                  | translate
              }}
            </span>
          </div>
        </div>

        <!-- System working correctly -->
        <div
          class="status__tiles__entry working-correctly"
          *ngIf="kanbanBoardStore.isSystemWorkingCorrectly$ | async"
        >
          <div class="status__tiles__entry__header">
            <h4>
              {{
                '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.WORKING_CORRECTLY_HEADER' | translate
              }}
            </h4>
            <mat-icon>check_circle</mat-icon>
          </div>
          <div class="status__tiles__entry__description">
            <span>
              {{
                '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.WORKING_CORRECTLY_DESCRIPTION'
                  | translate
              }}
            </span>
          </div>
        </div>
        <!-- async pipe used due to change detection issues -->
        <ng-container *ngrxLet="errors$ as errors">
          <ng-container *ngrxLet="hints$ as hints">
            <ng-container *ngrxLet="anomalies$ as anomalies">
              <!-- Errors -->
              <ng-container *ngFor="let error of errors; index as errorIndex">
                <ng-container
                  *ngIf="
                    isShowingMoreSystemStatuses ? true : errorIndex < defaultNumberOfVisibleErrors
                  "
                >
                  <div class="status__tiles__entry error">
                    <div class="status__tiles__entry__header">
                      <h4>{{ error.errorDescription }}</h4>
                      <app-pill [type]="pillType.error"> {{ error.errorCode }} </app-pill>
                    </div>
                    <div class="status__tiles__entry__description">
                      <span>{{ error.appearedAt | date: 'short' }}</span>
                      <ng-container *ngIf="error.loading; else dataLoaded">
                        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                      </ng-container>
                      <ng-template #dataLoaded>
                        <ng-container
                          *ngIf="error.error || error.cause?.length === 0; else displayErrorCause"
                        >
                          {{
                            'INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.ERROR_NO_DATA' | translate
                          }}
                        </ng-container>
                        <ng-template #displayErrorCause>
                          <div>
                            <span
                              >{{
                                '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.ERROR_CAUSE' | translate
                              }}
                            </span>
                            <span
                              *ngFor="let cause of error.cause"
                              [innerHTML]="cause | viTrustHtml"
                            ></span>
                          </div>
                        </ng-template>
                      </ng-template>
                    </div>
                    <!-- Todo redirect to GTS page with selected error -->
                    <!-- <div class="status__tiles__entry__button">
          <button mat-stroked-button>Repair now</button>
        </div> -->
                  </div>
                </ng-container>
              </ng-container>
              <!-- Warning / hints -->
              <ng-container *ngFor="let hint of hints; index as hintIndex">
                <div
                  *ngIf="
                    isShowingMoreSystemStatuses
                      ? true
                      : errors.length + hintIndex < defaultNumberOfVisibleErrors
                  "
                  class="status__tiles__entry warning"
                  [ngClass]="hint.status"
                >
                  <div class="status__tiles__entry__header">
                    <h4>{{ hint.header }}</h4>
                    <mat-icon *ngIf="!hint.status">notifications_active</mat-icon>
                  </div>
                  <div *ngIf="hint.description" class="status__tiles__entry__description">
                    <span>
                      {{ hint.description | translate }}
                    </span>
                  </div>
                  <div *ngIf="hint.buttonLabel" class="status__tiles__entry__button">
                    <button (click)="(hint.buttonMethod)" mat-stroked-button>
                      {{ hint.buttonLabel | translate }}
                    </button>
                  </div>
                </div>
              </ng-container>
              <!-- Critical / anomalies-->
              <ng-container
                *ngIf="(selectedDevice | highestSubscriptionPlan) === SubscriptionPlan.Pro"
              >
                <ng-container *ngFor="let anomaly of anomalies; index as anomalyIndex">
                  <div
                    *ngIf="
                      isShowingMoreSystemStatuses
                        ? true
                        : errors.length + hints.length + anomalyIndex < defaultNumberOfVisibleErrors
                    "
                    class="status__tiles__entry"
                    [ngClass]="'status-anomaly-' + anomaly.severity"
                  >
                    <div class="status__tiles__entry__header">
                      <h4>
                        {{ anomaly.header | translate }}
                      </h4>
                      <app-pill [type]="anomaly.pillType">
                        {{ anomaly.pillText }}
                      </app-pill>
                    </div>
                    <div class="status__tiles__entry__description">
                      <span>
                        {{ anomaly.description | translate }}
                      </span>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container
                *ngIf="
                  errors.length + hints.length + anomalies.length > defaultNumberOfVisibleErrors
                "
              >
                <button
                  class="status__tiles__button"
                  *ngIf="!isShowingMoreSystemStatuses"
                  mat-stroked-button
                  color="primary"
                  gtm="onSelect"
                  gtmAction="Show more quick view statuses"
                  gtmCategory="kanbanBoard"
                  (click)="manageStatusesListSize(true)"
                >
                  <span> {{ 'GENERAL.BUTTON.SHOW_MORE' | translate }} </span>
                  <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                </button>
                <button
                  class="status__tiles__button"
                  *ngIf="isShowingMoreSystemStatuses"
                  mat-stroked-button
                  color="primary"
                  gtm="onSelect"
                  gtmAction="Show less quick view  statuses"
                  gtmCategory="kanbanBoard"
                  (click)="manageStatusesListSize(false)"
                >
                  <span> {{ 'GENERAL.BUTTON.SHOW_LESS' | translate }} </span>
                  <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
                </button>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-template>
  <!-- Installation additional summary -->
  <div class="summary">
    <div
      class="summary__entry"
      *ngIf="
        selectedDevice?.heatingServiceTimeBased ||
        selectedDevice?.heatingServiceBurnerBased?.serviceIntervalBurnerHours ||
        selectedDevice?.heatingServiceBurnerBased?.activeBurnerHoursSinceLastService
      "
    >
      <span class="summary__entry__label">{{
        '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.MAINTENANCE' | translate
      }}</span>
      <ng-container *ngIf="selectedDevice.heatingServiceTimeBased; else timeBurnerBased">
        <span
          >{{ '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.MAINTENANCE_ON_DATE' | translate }}
          {{ selectedDevice.heatingServiceTimeBased.nextService | date: 'shortDate' }}</span
        >
      </ng-container>
      <ng-template #timeBurnerBased>
        <ng-container
          *ngIf="
            selectedDevice.heatingServiceBurnerBased.serviceIntervalBurnerHours &&
              selectedDevice.heatingServiceBurnerBased.activeBurnerHoursSinceLastService;
            else maintenanceInterval
          "
        >
          <span>
            {{
              '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.MAINTENANCE_IN_HOURS'
                | translate
                  : {
                      hours:
                        selectedDevice.heatingServiceBurnerBased.serviceIntervalBurnerHours -
                        selectedDevice.heatingServiceBurnerBased.activeBurnerHoursSinceLastService
                    }
            }}
          </span>
        </ng-container>
        <ng-template #maintenanceInterval>
          <span>
            {{
              '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.MAINTENANCE_INTERVAL_HOURS'
                | translate
                  : {
                      hours: selectedDevice.heatingServiceBurnerBased.serviceIntervalBurnerHours
                    }
            }}
          </span>
        </ng-template>
      </ng-template>
    </div>
    <div class="summary__entry" *ngIf="installation.owner">
      <span class="summary__entry__label">{{
        '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.OWNER' | translate
      }}</span>
      <span>{{ installation.owner.firstName }} {{ installation.owner.lastName }}</span>
    </div>
    <div class="summary__entry">
      <span class="summary__entry__label">
        {{ '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.ADDRESS' | translate }}
      </span>
      <div class="address-data">
        <span>{{ installation.address.street }} {{ installation.address.houseNumber }}</span>
        <span>{{ installation.address.zip }} {{ installation.address.city }}</span>
      </div>
    </div>
    <div
      class="summary__entry"
      *ngIf="installation.owner?.phoneNumber || installation.owner?.mobileNumber"
    >
      <span class="summary__entry__label">{{
        '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.PHONE' | translate
      }}</span>
      <span>
        {{ installation.owner.mobileNumber || installation.owner.phoneNumber | formatPhoneNumber }}
      </span>
    </div>
    <div class="summary__entry" *ngIf="installation.owner?.email">
      <span class="summary__entry__label">{{
        '+INSTALLATIONS.KANBAN_DASHBOARD.QUICK_VIEW.EMAIL' | translate
      }}</span>
      <span> {{ installation.owner.email }} </span>
    </div>
  </div>
</ng-container>
